import { Component } from '@angular/core';
import { StorylaneService } from '@app/shared/services/storylane.service';
import { StatementsFacade } from '../../../businesses/services/statements.facade';

@Component({
  standalone: false,
  selector: 'hospitable-statements-onboarding',
  templateUrl: './statements-onboarding.component.html',
  styleUrls: ['./statements-onboarding.component.scss'],
})
export class StatementsOnboardingComponent {
  constructor(
    private statementsService: StatementsFacade,
    private storylaneService: StorylaneService
  ) {
    this.statementsService.getTeam();

    // start the onboarding
    this.statementsService.onboardTeam().subscribe();
  }

  team$ = this.statementsService.teamState$;

  public takeTour() {
    this.storylaneService.tourOwnerStatements();
  }
}
